import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNoties } from '../../../modules/auth';
import useInterval from '../../../utils/useInterval';
import NotiBox from '../../../components/common/header/NotiBox';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import * as authApi from '../../../lib/api/auth';

const NotiContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNoties = async (checkedNoties) => {
    //console.log(checkedNoties,'chekedNoties');

    if (checkedNoties.length === 0) {
      enqueueSnackbar('선택된 알림이 없습니다.', {
        variant: 'error',
      });
      return;
    }

    try {
      // let dataToSubmit = {arr:checkedNoties};
      //console.log(checkedNoties.toString());
      const res = await authApi.confirmNoties(checkedNoties.toString());
      if (res.data.result === 'success') {
        dispatch(getNoties());
        handleClose();
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
  
  const handleNoti = async (noti) => {
    try {
      // let dataToSubmit = {arr:checkedNoties};
      //console.log(checkedNoties.toString());
      const res = await authApi.confirmNoties(noti.notiId.toString());
      if (res.data.result === 'success') {
        handleClose();
        dispatch(getNoties());
        navigate(noti.notiUrl);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleNotiAll = async () => {
    try {
      // let dataToSubmit = {arr:checkedNoties};
      //console.log(checkedNoties.toString());
      const res = await authApi.confirmNotiAll();
      if (res.data.result === 'success') {
        handleClose();
        dispatch(getNoties()); 
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };
  const { noties, notiCount } = useSelector(({ auth }) => ({
    noties: auth.noties,
    notiCount: auth.notiCount,
  }));

  useEffect(() => {
    dispatch(getNoties());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useInterval(() => {
    // Your custom logic here
    dispatch(getNoties());
  }, 1000 * 60 * 10); //10분마다

  const handleRefresh = () => {
    dispatch(getNoties());
    enqueueSnackbar('노티를 갱신하였습니다.', {
      variant: 'info',
    });
  };

  // noties, notiCount, onConfirmNoties, onRefresh
  return (
    <NotiBox
      noties={noties}
      notiCount={notiCount}
      onConfirmNoties={handleNoti}
      onConfirmNotiAll={handleNotiAll}
      // anchorEl={anchorEl}
      // handleClick={handleClick}
      // handleClose={handleClose}
      onRefresh={handleRefresh}
    />
  );
};

export default NotiContainer;
